import { useEffect } from "react";

/**
 * U8: a per-page browser-tab title. Every route used to show the same "Apna Shahar · Biswan
 * Online" (`applyCityBranding` sets it once), so a history list or a row of tabs read as identical.
 *
 * Prefixes the page's own name to whatever the document title is at mount ("Delhi Sweets · Apna
 * Shahar · Biswan Online") and puts the previous title back on unmount or when `title` changes, so
 * navigating away never leaves a stale name behind. A falsy `title` (data still loading) leaves
 * the brand title alone rather than flashing "undefined".
 */
export function usePageTitle(title) {
  useEffect(() => {
    if (!title) return undefined;
    const previous = document.title;
    document.title = `${title} · ${previous}`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
